import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import App from './App';
import reportWebVitals from './reportWebVitals';

// Safety net for errors that happen outside React's render cycle (event
// handlers, timers, unhandled promise rejections) — these don't trigger the
// ErrorBoundary and would otherwise fail silently in the console only.
window.addEventListener('error', (event) => {
  // eslint-disable-next-line no-console
  console.error('Unhandled global error:', event.error || event.message);
});
window.addEventListener('unhandledrejection', (event) => {
  // eslint-disable-next-line no-console
  console.error('Unhandled promise rejection:', event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();